import * as React from 'react';
export const pinSvg = React.forwardRef(function pinSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.151 1.388a2 2 0 0 0-2.597-.199L5.036 3.036l-.473-.473a1 1 0 0 0-1.238-.141L1.066 3.834a1 1 0 0 0-.177 1.555l2.33 2.33L.65 10.29a.75.75 0 0 0 1.06 1.061l2.57-2.57 2.331 2.331a1 1 0 0 0 1.555-.177l1.412-2.26a1 1 0 0 0-.14-1.236l-.475-.475 1.847-2.518a2 2 0 0 0-.199-2.597l-.46-.46Zm-2.19 4.574 1.72-2.345a.6.6 0 0 0-.06-.779l-.46-.46a.6.6 0 0 0-.779-.06l-2.344 1.72 1.924 1.924ZM3.799 3.778l-1.564.977 5.012 5.01.977-1.563-4.425-4.424Z',
    }),
  );
});
pinSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pin = {
  category: 'icon',
  colorable: true,
  name: 'pin',
  svg: pinSvg,
};
